module.exports = [{"id":1,"languageISO":"DE","languageDisplay":"DE"},{"id":2,"languageISO":"EN","languageDisplay":"EN"}]


//////////////////
// WEBPACK FOOTER
// ./src/i18n/availableLanguages.json
// module id = 123
// module chunks = 0